/* BSC Academy — scorrimento degli autori · v1 · 25/08/2026
   Tre alla volta. La misura si calcola dalla card e dal gap VERI: con un
   numero fisso basta cambiare la larghezza nel CSS e lo scorrimento sbaglia. */
(function () {
  'use strict';
  var PASSO = 3;

  function init(sez) {
    if (!sez || sez.dataset.bscAutInit) { return; }
    var pista = sez.querySelector('[data-bsc-aut-pista]');
    var prev = sez.querySelector('[data-bsc-aut-prev]');
    var next = sez.querySelector('[data-bsc-aut-next]');
    if (!pista || !prev || !next) { return; }
    sez.dataset.bscAutInit = '1';

    function quanto() {
      var it = pista.querySelector('li');
      if (!it) { return pista.clientWidth; }
      var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
      return (it.getBoundingClientRect().width + gap) * PASSO;
    }

    function stato() {
      var fine = pista.scrollWidth - pista.clientWidth - 2;
      prev.disabled = pista.scrollLeft <= 2;
      next.disabled = pista.scrollLeft >= fine;
    }

    prev.addEventListener('click', function () { pista.scrollBy({ left: -quanto(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { pista.scrollBy({ left:  quanto(), behavior: 'smooth' }); });
    pista.addEventListener('scroll', stato, { passive: true });
    window.addEventListener('resize', stato);
    stato();
  }

  function tutte(scope) {
    var n = (scope || document).querySelectorAll('.bsc-aut');
    for (var i = 0; i < n.length; i++) { init(n[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { tutte(document); });
  } else { tutte(document); }

  document.addEventListener('shopify:section:load', function (e) { tutte(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var n = e.target.querySelectorAll('.bsc-aut');
    for (var i = 0; i < n.length; i++) { delete n[i].dataset.bscAutInit; }
  });
})();
